<template>
  <q-dialog v-model="shown">
    <q-card
      :style="{ 'width': '450px', 'max-width': '95%' }"
    >
      <q-card-section
        class="text-h5"
      >
        Select Discount And Items
      </q-card-section>

      <q-card-section
        v-if="order"
      >
        <q-select
          v-model="discount"
          :options="discounts"
          option-label="displayName"
          emit-value
          label="Select Discount"
          stack-label
          :option-disable="option => !availableDiscounts.includes(option)"
          clearable
        />
      </q-card-section>

      <q-card-section
        v-if="order"
        :class="{ 'disabled-section': !discount }"
      >
        <model-table
          :collection="order.orderItems"
          selection="multiple"
          :columns="[
            { field: 'checkoutDescription', maxWidth: '250px' },
            { field: 'state', component: OrderStateCell },
          ]"
          :show-add="false"
          :show-edit="false"
          :filter-by-data-array="orderItems"
          row-key="id"
          :disable="!discount"
          @selected-input="selectedValues => selectedOrderItems = selectedValues"
        />
      </q-card-section>

      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Cancel"
          :outline="true"
        />
        <q-btn
          label="Apply Discount"
          color="primary"
          @click="applyManualDiscount"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'
export default {
  name: 'RegisterButtonManualDiscountDialog',
  components: {
    ModelTable
  },
  emits: ['apply-manual-discount'],
  data () {
    return {
      shown: false,
      order: null,
      discounts: null,
      discount: null,
      selectedOrderItems: []
    }
  },
  computed: {
    availableDiscounts () {
      return _.filter(this.discounts, discount => _.find(this.order.validOrderItems, orderItem => discount.validateDiscount(orderItem, this.order.orderItemPackageOnly, false, true)))
    },
    orderItems () {
      if (!this.discount) {
        return this.order.validOrderItems
      }
      return _.filter(this.order.validOrderItems, orderItem => this.discount.validateDiscount(orderItem, this.discount.orderItemPackageOnly, false, true) && orderItem.discount?.id !== this.discount.id)
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.order = null
        this.discount = null
        this.selectedOrderItems = []
        this.discounts = null
      }
    },
    discount () {
      // Filter out any selected items that are no longer valid for the new discount
      if (this.selectedOrderItems.length && this.discount && this.order) {
        this.selectedOrderItems = _.intersection(this.selectedOrderItems, this.orderItems)
      }
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      OrderStateCell
    })
  },
  methods: {
    async show (order, discounts) {
      this.discounts = discounts.data
      this.order = order
      this.shown = true
      await this.$nextTick() // Wait for elements to be rendered
    },
    applyManualDiscount () {
      this.$emit('apply-manual-discount', this.selectedOrderItems, this.discount)
      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-wrap: wrap;
}
.button {
  padding: 10px;
  height: 100%;
}
.disabled-section {
  opacity: 0.6;
  pointer-events: none;
}
</style>
